import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import axiosGet from "../../helpers/axiosGet";

import Button from "../../components/Button/Button";
import CertificateDetailKalog from "../../components/Detail/CertificateDetailKalog";
import FileFormKalog from "../../components/Form/FileFormKalog";
import Spinner from "../../components/Spinner/Spinner";
import Subheading from "../../components/Subheading/Subheading";
import DownloadCard from "../../components/Download/DownloadCard";

const formId = "claim-kalog-upload-docs";

const FormUploadDoc = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState({});
  const [claim, setClaim] = useState({});
  //   const [currentStatus, setCurrentStatus] = useState({});
  //   const [statusHistory, setStatusHistory] = useState([]);
  const [docs, setDocs] = useState([]);
  const [docsOther, setDocsOther] = useState([]);
  const [nextDisabled, setNextDisabled] = useState(false);
  //   const path = `${claim.insuranceCode}`;

  //   const [dataInvoice, setDataInvoice] = useState(null);
  const [filteredFieldsDocs, setFilteredFieldsDocs] = useState([]);
  const [conversationsLoaded, setConversationsLoaded] = useState(false);

  useEffect(() => {
    const getAllConversations = async () => {
      await axiosGet({
        url: `/claim-kalog/uniq-id/${id}`,
        callback: (res) => {
          // setLoading(false);
          setDetail(res.data);
          setClaim(res.data.claim);
          setConversationsLoaded(true);
          //   const claimCargoStatus = res.data.claimStatus;
          //   setStatusHistory(claimCargoStatus);
          //   setCurrentStatus(claimCargoStatus[0]);

          const claimCargoDocument = res.data.claimDocument;
          setDocs(claimCargoDocument);
          setDocsOther(
            claimCargoDocument.filter((doc) => doc.type === "DOC_OTHER")
          );
        },
        errorCallback: (err) => {
          setLoading(false);
          console.log(err);
        },
      });
    };
    getAllConversations();
  }, [id, navigate]);

  useEffect(() => {
    if (conversationsLoaded === true) {
      const getInvConversations = async () => {
        await axiosGet({
          url: `claim-kalog/document/uniq-id/${id}`,
          callback: (res) => {
            setLoading(false);
            const requiredDocs = res.data.requiredDocuments
            console.log("requiredDocs", requiredDocs)
            const fieldsDocs = requiredDocs.map(doc => ({
              name: doc.code,
              label: doc.desc.id
            }));

            const filteredFields = fieldsDocs.filter(
              (item) => item.name !== "DOC_OTHER"
            );

            setFilteredFieldsDocs(filteredFields)
          },
          errorCallback: (res) => {
            setLoading(false);
          },
        });
      };
      getInvConversations();
    }
    
  }, [conversationsLoaded, id]);

  const disableNext = (value) => {
    setNextDisabled(value);
  };

  const handleNext = (data) => {
    navigate(`/klaim-kalog/riwayat/${id}`);
  };

  return (
    <section className="overflow-hidden">
      {loading ? (
        <Spinner height={70} />
      ) : (
        <>
          <MDBRow className="g-4">
            <MDBCol lg="8">
              <Subheading>Dokumen Klaim</Subheading>

              <div className="mb-4">
                <MDBRow end>
                  <MDBCol lg="8" xl="6">
                    <div className="mb-3">
                      <DownloadCard
                        title="Download Template Formulir Klaim"
                        href={`/Form_Claim_Cargo_HARTA.pdf`}
                        download
                      />
                    </div>
                  </MDBCol>
                </MDBRow>
              </div>

              <FileFormKalog
                fields={filteredFieldsDocs}
                formId={formId}
                handleNext={handleNext}
                data={detail}
                docs={docs}
                docsOther={docsOther}
                disableNext={disableNext}
              />
            </MDBCol>

            <MDBCol lg="4">
              <Subheading>Detail Certificate</Subheading>

              <CertificateDetailKalog claim={claim} detail={detail} />
            </MDBCol>
          </MDBRow>

          <div className="d-flex justify-content-between mt-5">
            <Button
              secondary
              startIcon="arrow-left"
              onClick={() => navigate(`/klaim-kalog/riwayat/${id}`)}
              disabled={nextDisabled}
            >
              Kembali
            </Button>

            <Button
              endIcon="arrow-right"
              form={formId}
              type="submit"
              disabled={nextDisabled}
            >
              Selanjutnya
            </Button>
          </div>
        </>
      )}
    </section>
  );
};

export default FormUploadDoc;
